import { useQuery } from "@tanstack/react-query";
import { ErmineQueryKey } from "../utils/reactQueryKeyUtils";
import { AWSError } from "aws-sdk";
import {
    GetTermsOfServiceRequest,
    GetTermsOfServiceResponse,
} from "@amzn/ermine-ssr-sdk/clients/ermineserversiderenderingservice";
import log, { METRIC_NAME } from "../logging";
import { getErmineSsrClient } from "../utils/ermineSsrClientUtil";
import { getFormattedAwsErrorMessage, isAWSError } from "../utils/errorUtils";

export const useGetTermsOfService = (
    portalArn: string,
    userSettingsId: string
) => {
    const { data, isLoading, error, refetch, isError } = useQuery({
        queryKey: ErmineQueryKey.GetTermsOfService(portalArn, userSettingsId),
        queryFn: async () => {
            try {
                const output: GetTermsOfServiceResponse = await getErmineSsrClient()
                    .makeUnauthenticatedRequest("getTermsOfService", {
                        portalArn,
                    } as GetTermsOfServiceRequest)
                    .promise();
                log.publishMetricWithDimensions(
                    METRIC_NAME.CUSTOM_BRANDING_ASSET_SUCCESS,
                    {
                        resource: "TermsOfService",
                    }
                );
                return output.termsOfService;
            } catch (err) {
                await log.error(
                    isAWSError(err)
                        ? getFormattedAwsErrorMessage(err, "GetTermsOfService")
                        : "Failed to get terms of service"
                );
                log.publishMetricWithDimensions(
                    METRIC_NAME.MISSING_CUSTOM_BRANDING_ASSET,
                    {
                        resource: "TermsOfService",
                    }
                );
                throw err;
            }
        },
        enabled: !!portalArn && !!userSettingsId,
        staleTime: Infinity,
    });

    return {
        content: data,
        isLoading,
        error: error as AWSError | undefined,
        refetch,
        isError,
    };
};
